// extracted by mini-css-extract-plugin
module.exports = {"rightDivider":"CustomDivider_rightDivider___YNUI","line":"CustomDivider_line__ST1pq","expandLine":"CustomDivider_expandLine__RhZpo"};